import { render, staticRenderFns } from "./Duplicator.vue?vue&type=template&id=1b1729a4&"
import script from "./Duplicator.vue?vue&type=script&lang=js&"
export * from "./Duplicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports